import React from 'react';

export default function Footer() {
  let newDate = new Date()
  let year = newDate.getFullYear();
  let spacer = " | ";

  return (
      <footer>
          <span className="copyrightInfo">Copyright © {year} Imagine Learning, LLC. All rights reserved.</span>
          <span className="aboutUs"><a href="https://www.imaginelearning.com/en/us/about" target="_blank">About Us</a>{spacer}</span>
          <span className="privacyPolicy"><a href="https://www.imaginelearning.com/support/privacy/" target="_blank">Privacy Policy & Terms of Use</a></span>
      </footer>
  );
}